import { AlertTriangle } from 'lucide-react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './brief-gaps-banner.module.scss';

const styles = {
  root: pickCss(css, css.root),
  icon: pickCss(css, css.icon),
  label: pickCss(css, css.label),
  count: pickCss(css, css.count),
};

type BriefGapsBannerProps = {
  count: number;
  onClick?: () => void;
};

/**
 * BriefGapsBanner — pen component `m2eNng`. The compact amber summary row
 * shown when there is at least one open brief gap. Clicking it expands the
 * full `BriefGapsPanel`.
 */
export const BriefGapsBanner = ({ count, onClick }: BriefGapsBannerProps) => {
  if (count <= 0) return null;
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      className={styles.root()}
      onClick={onClick}
      type={onClick ? 'button' : undefined}
    >
      <span aria-hidden="true" className={styles.icon()}>
        <AlertTriangle size={13} />
      </span>
      <span className={styles.label()}>
        A few things missing that could affect the plan
      </span>
      <span className={styles.count()}>{count}</span>
    </Tag>
  );
};
